import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseOrdersReport() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();
  const { toGregorian, toSolar } = require("jdate-convert");

  function validate(state, imgState, setter) {
    let errorState = {
      title: isEmpty(state.title),
      url: isEmpty(state.url),
      file1: isEmpty(imgState.url1),
      file2: isEmpty(imgState.url2),
    };

    setter(errorState);

    if (errorState.title || errorState.url) {
      enqueueSnackbar("لطفا اطلاعات اسلاید را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetDailyReport = (Year, Month, myPC, bool, callback) => {
    let newMyPc = myPC;
    if (myPC.sortColumn == "ShamsiOrderDate") {
      newMyPc.sortColumn = "Orderdate";
    }
    MyAxios.get(`Admin_OrdersReport/D/${Year}/${Month}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: newMyPc }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetMonthlyReport = (Year, myPC, callback) => {
    let newMyPc = myPC;
    if (myPC.sortColumn == "ShamsiOrderDate") {
      newMyPc.sortColumn = "Orderdate";
    }
    MyAxios.get(`Admin_OrdersReport/M/${Year}`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: newMyPc }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetAnnualReport = (myPC, callback) => {
    let newMyPc = myPC;
    if (myPC.sortColumn == "ShamsiOrderDate") {
      newMyPc.sortColumn = "Orderdate";
    }
    MyAxios.get(`Admin_OrdersReport/Y`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: newMyPc }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetGeneralDetails = (startDate, endDate, callback) => {
    MyAxios.get(`Admin_OrdersReport/Detail/${startDate}/${endDate}/0`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const ExportList = (startDate, endDate, callback) => {
    MyAxios.get(`Admin_OrdersReport/Export/${startDate}/${endDate}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };

  const GetProductDetails = (startDate, endDate, callback) => {
    MyAxios.get(`Admin_OrdersReport/Detail/${startDate}/${endDate}/1`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const GetCategoryDetails = (startDate, endDate, callback) => {
    MyAxios.get(`Admin_OrdersReport/Detail/${startDate}/${endDate}/2`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const GetBrandDetails = (startDate, endDate, callback) => {
    MyAxios.get(`Admin_OrdersReport/Detail/${startDate}/${endDate}/3`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const GetGroupDetails = (startDate, endDate, callback) => {
    MyAxios.get(`Admin_OrdersReport/Detail/${startDate}/${endDate}/4`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const UpdateDailyReport = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_OrdersReport`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("گزارش به‌روزرسانی شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const removeComponent = (AID, callback) => {
    const data = new FormData();
    data.append("AID", AID);
    MyAxios.delete(`Admin_OrdersReport/RemoveComponent`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("کامپوننت با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    GetDailyReport,
    GetMonthlyReport,
    GetAnnualReport,
    GetGeneralDetails,
    GetProductDetails,
    GetCategoryDetails,
    GetBrandDetails,
    GetGroupDetails,
    validate,
    removeComponent,
    UpdateDailyReport,
    ExportList,
  };
}
